import { Language, PartlistColumn, PartlistColumnFilter, PartlistEntryFilter, PartlistEntryUsage } from "@org-avp/avp-avengers-partlist-service-api";
import { SamFilterSource, SamFilterState, SamFilterType, SamTypeCheckedFilter } from "../filterTypes";

export interface PartlistSelection {
  partlistEntryIds: string[];
  additionalKeys: {
    bomPartKey: string;
    geometryEntryId?: string;
    geometryKey?: string;
  }[];
}

export enum PartlistFilterableField {
  PARTLIST_ENTRY_ID = "PARTLIST_ENTRY_ID",
  BOM_BASE_NUMBER = "BOM_BASE_NUMBER",
  BOM_PART_KEY = "BOM_PART_KEY",
  TIME_RANGE = "TIME_RANGE",
  USAGE = "USAGE",
}

export interface PartlistFilterQueryParams {
  projectId: string;
  subprojectId: string;
  partlistEntryFilters: PartlistEntryFilter[];
  partlistColumnFilters: PartlistColumnFilter[];
  partlistColumns: PartlistColumn[];
  language: Language;
}

export type PartlistFilterState = SamFilterState<PartlistFilter>;
export type PartlistFilter = SamTypeCheckedFilter<[
  {
    field: PartlistFilterableField.PARTLIST_ENTRY_ID;
    operator: "==" | "!=";
    value: string;
  },
  {
    field: PartlistFilterableField.PARTLIST_ENTRY_ID;
    operator: "in" | "!in";
    value: string[];
  },
  {
    field: PartlistFilterableField.BOM_BASE_NUMBER;
    operator: "==" | "!=" | "contains";
    value: string;
  },
  {
    field: PartlistFilterableField.BOM_BASE_NUMBER;
    operator: "in" | "!in";
    value: string[];
  },
  {
    field: PartlistFilterableField.BOM_PART_KEY;
    operator: "==" | "!=" | "contains";
    value: string;
  },
  {
    field: PartlistFilterableField.BOM_PART_KEY;
    operator: "in" | "!in";
    value: string[];
  },
  {
    field: PartlistFilterableField.TIME_RANGE;
    operator: "between";
    value: [string, string];
  },
  {
    field: PartlistFilterableField.USAGE;
    operator: "==";
    value: PartlistEntryUsage;
  },
  {
    field: PartlistFilterableField.USAGE;
    operator: "in" | "!in";
    value: PartlistEntryUsage[];
  },
]>;

export interface InvertPartlistEntriesAction {
  partlistEntryIds: string[];
  source: SamFilterSource;
  type: SamFilterType;
}
